import React from 'react';
import styles from './BtnPrimary.module.scss'

const BtnOrange = ({children, onClick, style}) => {
    const defaultStyle = {
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        width: "50px",
        height: "50px",
        color: "white",
        borderRadius: "60px 60px 60px 4px",
        background: "var(--SEIZO-orange, #FF9436)",
        cursor: "pointer"
    };

    const handleClick = (e) => {
        if (onClick) {
            onClick(e);
        }
    };

    return (
        <div onClick={handleClick} style={{...defaultStyle, ...style}}>
            {children}
        </div>
    );
};

export default BtnOrange;
